export const getImageUrl = ({ nftId, chainId, contract }) => {
  return `https://memori-nft.s3.us-west-1.amazonaws.com/${chainId}/${contract}/${nftId}/image.png`;
};
